import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './AppNew';
import './styles.css';

// React's error boundary only catches render-time errors. Promise rejections from
// Supabase / fetch / dynamic imports never reach it — they previously vanished
// into the console silently. Logging them centrally is a first step toward
// piping into Sentry, and at least surfaces silent failures during dev.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[unhandledrejection]', event.reason);
  });
  window.addEventListener('error', (event) => {
    if (event.error) console.error('[window.error]', event.error);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
